import React from 'react';

import { Flex } from '@rover/kibble/core';
import type { SvgIcon } from '@rover/types/src/SvgIcon';

type BadgeProps = {
  iconColor: string;
  backgroundColor: string;
  icon: SvgIcon;
};

const CIRCLE_SIZE = 40;
const ICON_SIZE = 24;

const Badge: React.FC<BadgeProps> = ({ iconColor, backgroundColor, icon: IconComponent }) => {
  return (
    <Flex
      data-testid="badge-container"
      position="relative"
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      width={CIRCLE_SIZE}
      height={CIRCLE_SIZE}
      backgroundColor={backgroundColor}
    >
      <IconComponent width={ICON_SIZE} height={ICON_SIZE} fill={iconColor} />
    </Flex>
  );
};
export default Badge;
